export default __webpack_public_path__ + "static/media/POS-02.f80220fe.png";